/**
 * Tek kaynaklı çalışma zamanı modu bilgisi.
 *
 * Mock/gerçek API kararı yalnızca burada `VITE_USE_MOCKS` bayrağından okunur.
 * Mock fetch interceptor'ı (`src/mocks`) ve arayüz (sidebar mod rozeti,
 * giriş ekranındaki demo kimlik bloğu) aynı yardımcıyı kullanır; bayrağın
 * yorumu hiçbir yerde tekrarlanmaz.
 */
import { API_BASE } from "../api/client";

/** Mock API devrede mi? `VITE_USE_MOCKS=false` ile kapatılır, varsayılan açık. */
export function mocksEnabled(): boolean {
  return import.meta.env.VITE_USE_MOCKS !== "false";
}

/** Sidebar altındaki mod rozetinin etiketi: mock ya da canlı API. */
export function dataModeBadge(): string {
  return mocksEnabled()
    ? "Faz 2 MVP · mock veri modu"
    : `Faz 2 MVP · canlı API — ${API_BASE}`;
}
